import { useState, useEffect, useRef } from "react";

const API = "https://api.garage.anaclia.fr";
const CATS = ["Tous","Moteur","Freinage","Transmission","Pneumatiques","Commandes","Autre"];
const TYPES_REP = ["Révision complète","Vidange + filtre","Remplacement plaquettes","Remplacement chaîne","Montage pneu","Diagnostic électronique","Autre"];

const fmt = (n) => Number(n||0).toFixed(2).replace(".", ",") + " €";
const today = () => new Date().toISOString().split("T")[0];
const fmtDate = (d) => d ? new Date(d).toLocaleDateString("fr-FR") : "-";

function stockSt(qty, seuil) {
  if (qty === 0)    return { label:"Rupture", color:"#dc2626", bg:"#fef2f2" };
  if (qty <= seuil) return { label:"Bas",     color:"#d97706", bg:"#fffbeb" };
  return                   { label:"OK",      color:"#16a34a", bg:"#f0fdf4" };
}
function repSt(s) {
  if (s === "Terminée")   return { color:"#16a34a", bg:"#f0fdf4" };
  if (s === "En cours")   return { color:"#2563eb", bg:"#eff6ff" };
  if (s === "En attente") return { color:"#d97706", bg:"#fffbeb" };
  return { color:"#6b7280", bg:"#f9fafb" };
}

const C = {
  G:"#1D9E75", GD:"#0F6E56", GL:"#f0fdf4", GB:"#bbf7d0",
  BG:"#f5f7f6", SU:"#ffffff", BR:"#e4eae7",
  TX:"#111b17", MU:"#5a7068", LI:"#9ab0a8",
};

function Badge({ label, color, bg }) {
  return <span style={{ background:bg, color, fontSize:11, fontWeight:500, padding:"2px 10px", borderRadius:20, whiteSpace:"nowrap" }}>{label}</span>;
}

function Btn({ children, onClick, variant="primary", small=false }) {
  const S = {
    primary:   { background:C.G,           color:"#fff", border:"none" },
    secondary: { background:"transparent", color:C.TX,   border:`0.5px solid ${C.BR}` },
    ghost:     { background:"transparent", color:C.MU,   border:"none" },
    danger:    { background:"transparent", color:"#dc2626", border:"0.5px solid #fecaca" },
  };
  return (
    <button onClick={onClick} style={{ ...S[variant], padding:small?"5px 12px":"8px 16px", borderRadius:7, cursor:"pointer", fontSize:small?12:13, fontWeight:500, display:"flex", alignItems:"center", gap:6 }}>
      {children}
    </button>
  );
}

function Inp({ label, value, onChange, type="text", placeholder }) {
  return (
    <div style={{ marginBottom:10 }}>
      {label && <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>{label}</div>}
      <input type={type} value={value||""} onChange={onChange} placeholder={placeholder}
        style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, color:C.TX, background:C.SU, outline:"none", boxSizing:"border-box" }}/>
    </div>
  );
}

function Sel({ label, value, onChange, children }) {
  return (
    <div style={{ marginBottom:10 }}>
      {label && <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>{label}</div>}
      <select value={value||""} onChange={onChange}
        style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, outline:"none", background:C.SU, color:C.TX, boxSizing:"border-box" }}>
        {children}
      </select>
    </div>
  );
}

function Stat({ label, value, color, sub }) {
  return (
    <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:10, padding:"16px 20px", flex:1, minWidth:120 }}>
      <div style={{ fontSize:11, color:C.MU, textTransform:"uppercase", letterSpacing:.5, marginBottom:6 }}>{label}</div>
      <div style={{ fontSize:24, fontWeight:500, color:color||C.TX }}>{value}</div>
      {sub && <div style={{ fontSize:11, color:C.LI, marginTop:4 }}>{sub}</div>}
    </div>
  );
}

function Modal({ title, onClose, children, width=480 }) {
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.35)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:200, padding:20, overflowY:"auto" }}>
      <div style={{ background:C.SU, borderRadius:14, border:`0.5px solid ${C.BR}`, padding:28, width:"100%", maxWidth:width, display:"flex", flexDirection:"column", gap:14, maxHeight:"90vh", overflowY:"auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div style={{ fontSize:17, fontWeight:500 }}>{title}</div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:20, color:C.MU }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function UploadBtn({ label, type, variant, onFile }) {
  const ref = useRef(null);
  return (
    <>
      <input ref={ref} type="file" accept=".pdf,image/*" style={{ display:"none" }}
        onChange={e => { if (e.target.files[0]) onFile(e.target.files[0], type); e.target.value = ""; }}/>
      <Btn variant={variant} onClick={() => ref.current.click()}>📄 {label}</Btn>
    </>
  );
}

function LoginPage({ onLogin }) {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const handle = () => {
    if (email === "admin@garage.fr" && password === "Garage2026") {
      onLogin({ nom:"Dubois Pierre", role:"Admin", email });
    } else {
      setError("Email ou mot de passe incorrect.");
    }
  };
  return (
    <div style={{ minHeight:"100vh", background:C.BG, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:16, padding:40, width:"100%", maxWidth:400 }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🔧</div>
          <div style={{ fontSize:22, fontWeight:600, color:C.GD }}>Garage Pro</div>
          <div style={{ fontSize:13, color:C.MU, marginTop:4 }}>Connectez-vous à votre espace</div>
        </div>
        <Inp label="Email" value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="admin@garage.fr"/>
        <Inp label="Mot de passe" value={password} onChange={e=>setPassword(e.target.value)} type="password" placeholder="••••••••"/>
        {error && <div style={{ background:"#fef2f2", border:"0.5px solid #fecaca", borderRadius:7, padding:"8px 12px", fontSize:12, color:"#dc2626" }}>{error}</div>}
        <button onClick={handle} style={{ width:"100%", padding:"10px", background:C.G, color:"#fff", border:"none", borderRadius:7, fontSize:14, fontWeight:500, cursor:"pointer", marginTop:8 }}>
          Se connecter
        </button>
      </div>
    </div>
  );
}

// ── FICHE FOURNISSEUR ─────────────────────────────────────────────────────────
function FicheFournisseur({ id, onBack, onUpdate }) {
  const [data, setData]   = useState(null);
  const [edit, setEdit]   = useState(false);
  const [form, setForm]   = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/fournisseurs/${id}`).then(r=>r.json()).then(d => {
      setData(d); setForm(d); setLoading(false);
    });
  }, [id]);

  const save = async () => {
    await fetch(`${API}/api/fournisseurs/${id}`, { method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify(form) });
    setData(f => ({...f, ...form}));
    setEdit(false);
    if (onUpdate) onUpdate();
  };

  if (loading) return <div style={{ padding:40, textAlign:"center", color:C.MU }}>Chargement...</div>;
  if (!data)   return <div style={{ padding:40, textAlign:"center", color:C.MU }}>Fournisseur non trouvé</div>;

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
        <button onClick={onBack} style={{ background:"none", border:`0.5px solid ${C.BR}`, borderRadius:7, padding:"6px 12px", cursor:"pointer", fontSize:13, color:C.MU }}>← Retour</button>
        <div style={{ fontSize:22, fontWeight:500 }}>{data.nom}</div>
        <div style={{ marginLeft:"auto", display:"flex", gap:8 }}>
          {edit ? (
            <>
              <Btn variant="secondary" onClick={()=>setEdit(false)}>Annuler</Btn>
              <Btn onClick={save}>💾 Enregistrer</Btn>
            </>
          ) : (
            <Btn variant="secondary" onClick={()=>setEdit(true)}>✏️ Modifier</Btn>
          )}
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <div style={{ display:"flex", gap:12, flexWrap:"wrap" }}>
          <Stat label="Total achats"  value={fmt(data.total_achats)} color={C.G}/>
          <Stat label="Nb factures"   value={data.nb_factures}/>
          <Stat label="Délai livraison" value={`${data.delai}j`}/>
          <Stat label="Remise"        value={`${data.remise}%`}/>
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>📋 Coordonnées</div>
          {edit ? (
            <>
              <Inp label="Nom"                value={form.nom}                 onChange={e=>setForm(p=>({...p,nom:e.target.value}))}/>
              <Inp label="Contact"            value={form.contact}             onChange={e=>setForm(p=>({...p,contact:e.target.value}))}/>
              <Inp label="Téléphone"          value={form.tel}                 onChange={e=>setForm(p=>({...p,tel:e.target.value}))}/>
              <Inp label="Email"              value={form.email}               onChange={e=>setForm(p=>({...p,email:e.target.value}))} type="email"/>
              <Inp label="Adresse"            value={form.adresse}             onChange={e=>setForm(p=>({...p,adresse:e.target.value}))}/>
              <Inp label="Site web"           value={form.site_web}            onChange={e=>setForm(p=>({...p,site_web:e.target.value}))}/>
              <Inp label="Délai (jours)"      value={form.delai}               onChange={e=>setForm(p=>({...p,delai:e.target.value}))} type="number"/>
              <Inp label="Remise (%)"         value={form.remise}              onChange={e=>setForm(p=>({...p,remise:e.target.value}))} type="number"/>
              <Inp label="Conditions paiement" value={form.conditions_paiement} onChange={e=>setForm(p=>({...p,conditions_paiement:e.target.value}))}/>
            </>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {[
                ["👤 Contact", data.contact],
                ["📞 Téléphone", data.tel],
                ["✉️ Email", data.email],
                ["📍 Adresse", data.adresse],
                ["🌐 Site web", data.site_web],
                ["💳 Conditions", data.conditions_paiement],
              ].map(([label, val]) => val && (
                <div key={label} style={{ display:"flex", gap:8, fontSize:13 }}>
                  <span style={{ color:C.MU, minWidth:100 }}>{label}</span>
                  <span style={{ fontWeight:500 }}>{val}</span>
                </div>
              ))}
            </div>
          )}
          {edit && (
            <div>
              <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>Notes</div>
              <textarea value={form.notes||""} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, outline:"none", height:80, resize:"vertical", boxSizing:"border-box" }}/>
            </div>
          )}
          {!edit && data.notes && (
            <div style={{ marginTop:12, padding:"10px 12px", background:C.BG, borderRadius:7, fontSize:12, color:C.MU }}>📝 {data.notes}</div>
          )}
        </div>

        <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>📦 Pièces fournies</div>
          {data.pieces && data.pieces.length > 0 ? data.pieces.map(p => {
            const st = stockSt(p.qty, p.seuil);
            return (
              <div key={p.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"7px 0", borderBottom:`0.5px solid ${C.BR}` }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:500 }}>{p.nom}</div>
                  <div style={{ fontSize:11, color:C.MU }}>{p.ref}</div>
                </div>
                <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                  <Badge label={`${p.qty} en stock`} color={st.color} bg={st.bg}/>
                  <span style={{ fontSize:12, color:C.MU }}>{fmt(p.prix_vente)}</span>
                </div>
              </div>
            );
          }) : <div style={{ fontSize:13, color:C.LI }}>Aucune pièce enregistrée pour ce fournisseur.</div>}
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
        <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>🧾 Factures d'achat</div>
          {data.factures && data.factures.length > 0 ? data.factures.map(f => (
            <div key={f.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${C.BR}` }}>
              <div>
                <div style={{ fontSize:13, fontWeight:500 }}>{f.numero || `Facture #${f.id}`}</div>
                <div style={{ fontSize:11, color:C.MU }}>{fmtDate(f.date)}</div>
              </div>
              <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                <span style={{ fontSize:13, fontWeight:500 }}>{fmt(f.total_ht)}</span>
                {f.pdf_path && (
                  <a href={`${API}/pdfs/${f.pdf_path}`} target="_blank" rel="noreferrer" style={{ fontSize:11, color:C.G, textDecoration:"none", border:`0.5px solid ${C.GB}`, padding:"2px 8px", borderRadius:4 }}>📄 PDF</a>
                )}
              </div>
            </div>
          )) : <div style={{ fontSize:13, color:C.LI }}>Aucune facture enregistrée.</div>}
        </div>

        <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>📋 Bons de commande</div>
          {data.bons_commande && data.bons_commande.length > 0 ? data.bons_commande.map(b => {
            const st = repSt(b.statut);
            return (
              <div key={b.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${C.BR}` }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:500 }}>BC #{b.id}</div>
                  <div style={{ fontSize:11, color:C.MU }}>{fmtDate(b.date)}</div>
                </div>
                <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                  <Badge label={b.statut} color={st.color} bg={st.bg}/>
                  <span style={{ fontSize:13, fontWeight:500 }}>{fmt(b.total_ht)}</span>
                </div>
              </div>
            );
          }) : <div style={{ fontSize:13, color:C.LI }}>Aucun bon de commande.</div>}
        </div>
      </div>
    </div>
  );
}

// ── FICHE CLIENT ──────────────────────────────────────────────────────────────
function FicheClient({ id, onBack, clients, reps, onAddRep }) {
  const [data, setData]   = useState(null);
  const [edit, setEdit]   = useState(false);
  const [form, setForm]   = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/clients/${id}`).then(r=>r.json()).then(d => {
      setData(d); setForm(d); setLoading(false);
    });
  }, [id]);

  const save = async () => {
    await fetch(`${API}/api/clients/${id}`, { method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify(form) });
    setData(f => ({...f, ...form}));
    setEdit(false);
  };

  if (loading) return <div style={{ padding:40, textAlign:"center", color:C.MU }}>Chargement...</div>;
  if (!data)   return <div style={{ padding:40, textAlign:"center", color:C.MU }}>Client non trouvé</div>;

  const clientReps = data.reparations || [];
  const totalDepense = clientReps.reduce((a,r) => a + parseFloat(r.total||0), 0);

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
        <button onClick={onBack} style={{ background:"none", border:`0.5px solid ${C.BR}`, borderRadius:7, padding:"6px 12px", cursor:"pointer", fontSize:13, color:C.MU }}>← Retour</button>
        <div style={{ fontSize:22, fontWeight:500 }}>{data.nom}</div>
        <div style={{ marginLeft:"auto", display:"flex", gap:8 }}>
          {edit ? (
            <>
              <Btn variant="secondary" onClick={()=>setEdit(false)}>Annuler</Btn>
              <Btn onClick={save}>💾 Enregistrer</Btn>
            </>
          ) : (
            <Btn variant="secondary" onClick={()=>setEdit(true)}>✏️ Modifier</Btn>
          )}
          <Btn onClick={()=>onAddRep(id)}>+ Réparation</Btn>
        </div>
      </div>

      <div style={{ display:"flex", gap:12, marginBottom:16, flexWrap:"wrap" }}>
        <Stat label="Total dépensé"       value={fmt(totalDepense)}      color={C.G}/>
        <Stat label="Interventions"        value={clientReps.length}/>
        <Stat label="Kilométrage"          value={`${Number(data.km||0).toLocaleString()} km`}/>
        <Stat label="Véhicule"             value={data.vehicule || "-"}/>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>👤 Informations client</div>
          {edit ? (
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
              <Inp label="Nom *"          value={form.nom}      onChange={e=>setForm(p=>({...p,nom:e.target.value}))}/>
              <Inp label="Véhicule"       value={form.vehicule} onChange={e=>setForm(p=>({...p,vehicule:e.target.value}))}/>
              <Inp label="Téléphone"      value={form.tel}      onChange={e=>setForm(p=>({...p,tel:e.target.value}))}/>
              <Inp label="Email"          value={form.email}    onChange={e=>setForm(p=>({...p,email:e.target.value}))} type="email"/>
              <Inp label="Immatriculation" value={form.immat}   onChange={e=>setForm(p=>({...p,immat:e.target.value}))}/>
              <Inp label="Kilométrage"    value={form.km}       onChange={e=>setForm(p=>({...p,km:e.target.value}))} type="number"/>
              <div style={{ gridColumn:"1/-1" }}>
                <Inp label="Adresse" value={form.adresse} onChange={e=>setForm(p=>({...p,adresse:e.target.value}))}/>
              </div>
              <div style={{ gridColumn:"1/-1" }}>
                <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>Notes</div>
                <textarea value={form.notes||""} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, outline:"none", height:72, resize:"vertical", boxSizing:"border-box" }}/>
              </div>
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {[
                ["🏍 Véhicule",       data.vehicule],
                ["📞 Téléphone",      data.tel],
                ["✉️ Email",          data.email],
                ["🪪 Immatriculation", data.immat],
                ["📍 Adresse",        data.adresse],
              ].map(([label, val]) => val && (
                <div key={label} style={{ display:"flex", gap:8, fontSize:13 }}>
                  <span style={{ color:C.MU, minWidth:120 }}>{label}</span>
                  <span style={{ fontWeight:500 }}>{val}</span>
                </div>
              ))}
              {data.notes && <div style={{ marginTop:8, padding:"10px 12px", background:C.BG, borderRadius:7, fontSize:12, color:C.MU }}>📝 {data.notes}</div>}
            </div>
          )}
        </div>

        <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>📊 Répartition des interventions</div>
          {clientReps.length === 0 ? (
            <div style={{ fontSize:13, color:C.LI }}>Aucune intervention enregistrée.</div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
              {Object.entries(clientReps.reduce((acc, r) => { acc[r.statut] = (acc[r.statut]||0)+1; return acc; }, {})).map(([statut, count]) => {
                const st = repSt(statut);
                return (
                  <div key={statut} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 10px", background:st.bg, borderRadius:7 }}>
                    <span style={{ fontSize:13, color:st.color, fontWeight:500 }}>{statut}</span>
                    <span style={{ fontSize:13, fontWeight:500, color:st.color }}>{count} intervention{count>1?"s":""}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
        <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>🔧 Historique des réparations</div>
        {clientReps.length === 0 ? (
          <div style={{ fontSize:13, color:C.LI }}>Aucune réparation enregistrée.</div>
        ) : clientReps.map(r => {
          const st = repSt(r.statut);
          return (
            <div key={r.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", padding:"12px 0", borderBottom:`0.5px solid ${C.BR}` }}>
              <div>
                <div style={{ fontSize:13, fontWeight:500 }}>{r.type}</div>
                <div style={{ fontSize:11, color:C.MU, marginTop:2 }}>{fmtDate(r.date)}{r.km ? ` · ${Number(r.km).toLocaleString()} km` : ""}</div>
                {r.notes && <div style={{ fontSize:11, color:C.MU, fontStyle:"italic", marginTop:4 }}>📝 {r.notes}</div>}
              </div>
              <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                <Badge label={r.statut} color={st.color} bg={st.bg}/>
                <span style={{ fontSize:14, fontWeight:500 }}>{fmt(r.total)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── APP PRINCIPALE ────────────────────────────────────────────────────────────
export default function App() {
  const [user,         setUser]         = useState(null);
  const [page,         setPage]         = useState("dashboard");
  const [stock,        setStock]        = useState([]);
  const [clients,      setClients]      = useState([]);
  const [reps,         setReps]         = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [loading,      setLoading]      = useState(false);
  const [cat,          setCat]          = useState("Tous");
  const [search,       setSearch]       = useState("");
  const [selectedFourn,setSelectedFourn]= useState(null);
  const [selectedClient,setSelectedClient]= useState(null);
  const [iaModal,      setIaModal]      = useState(false);
  const [iaLoading,    setIaLoading]    = useState(false);
  const [iaResult,     setIaResult]     = useState(null);
  const [iaType,       setIaType]       = useState("achat");
  const [iaFile,       setIaFile]       = useState(null);
  const [addPiece,     setAddPiece]     = useState(false);
  const [addClient,    setAddClient]    = useState(false);
  const [addRep,       setAddRep]       = useState(false);
  const [addFourn,     setAddFourn]     = useState(false);
  const [editQty,      setEditQty]      = useState(null);
  const [tempQty,      setTempQty]      = useState("");
  const [garage,       setGarage]       = useState({ nom:"Garage Dubois", adresse:"15 rue de l'Atelier, 75011 Paris", tel:"01 23 45 67 89", email:"contact@garage-dubois.fr", siret:"123 456 789 00012", tva:"FR12 123456789", taux_horaire:"55" });
  const [newPiece,     setNewPiece]     = useState({ nom:"", ref:"", categorie:"Moteur", qty:"", seuil:"", prix_achat:"", prix_vente:"" });
  const [newClient,    setNewClient]    = useState({ nom:"", vehicule:"", tel:"", email:"", immat:"", km:"", adresse:"", notes:"" });
  const [newRep,       setNewRep]       = useState({ clientId:"", type:"Révision complète", date:today(), km:"", notes:"", statut:"En cours", total:"" });
  const [newFourn,     setNewFourn]     = useState({ nom:"", contact:"", tel:"", email:"", delai:"3", remise:"0", adresse:"", site_web:"", notes:"", conditions_paiement:"" });

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    Promise.all([
      fetch(`${API}/api/pieces`).then(r=>r.json()),
      fetch(`${API}/api/clients`).then(r=>r.json()),
      fetch(`${API}/api/reparations`).then(r=>r.json()),
      fetch(`${API}/api/fournisseurs`).then(r=>r.json()),
    ]).then(([p,c,r,f]) => {
      setStock(p); setClients(c); setReps(r); setFournisseurs(f);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [user]);

  if (!user) return <LoginPage onLogin={u => { setUser(u); setPage("dashboard"); }} />;

  if (loading) return (
    <div style={{ minHeight:"100vh", background:C.BG, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <div style={{ textAlign:"center" }}>
        <div style={{ fontSize:32, marginBottom:12 }}>🔧</div>
        <div style={{ fontSize:14, color:C.MU }}>Chargement des données...</div>
      </div>
    </div>
  );

  const reload = () => {
    Promise.all([
      fetch(`${API}/api/pieces`).then(r=>r.json()),
      fetch(`${API}/api/clients`).then(r=>r.json()),
      fetch(`${API}/api/reparations`).then(r=>r.json()),
      fetch(`${API}/api/fournisseurs`).then(r=>r.json()),
    ]).then(([p,c,r,f]) => { setStock(p); setClients(c); setReps(r); setFournisseurs(f); });
  };

  const apiUpdateQty = async (id, qty) => {
    await fetch(`${API}/api/pieces/${id}`, { method:"PUT", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ qty }) });
    setStock(p => p.map(s => s.id===id ? {...s, qty} : s));
  };
  const apiDeletePiece = async (id) => {
    await fetch(`${API}/api/pieces/${id}`, { method:"DELETE" });
    setStock(p => p.filter(s => s.id!==id));
  };
  const apiAddPiece = async () => {
    if (!newPiece.nom || !newPiece.ref) return;
    const res = await fetch(`${API}/api/pieces`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(newPiece) });
    const row = await res.json();
    setStock(p => [...p, row]);
    setNewPiece({ nom:"", ref:"", categorie:"Moteur", qty:"", seuil:"", prix_achat:"", prix_vente:"" });
    setAddPiece(false);
  };
  const apiAddClient = async () => {
    if (!newClient.nom || !newClient.vehicule) return;
    const res = await fetch(`${API}/api/clients`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(newClient) });
    const row = await res.json();
    setClients(p => [...p, row]);
    setNewClient({ nom:"", vehicule:"", tel:"", email:"", immat:"", km:"", adresse:"", notes:"" });
    setAddClient(false);
  };
  const apiDeleteClient = async (id) => {
    await fetch(`${API}/api/clients/${id}`, { method:"DELETE" });
    setClients(p => p.filter(c => c.id!==id));
  };
  const apiAddRep = async () => {
    if (!newRep.clientId) return;
    const res = await fetch(`${API}/api/reparations`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(newRep) });
    const row = await res.json();
    setReps(p => [row, ...p]);
    setNewRep({ clientId:"", type:"Révision complète", date:today(), km:"", notes:"", statut:"En cours", total:"" });
    setAddRep(false);
  };
  const apiDeleteRep = async (id) => {
    await fetch(`${API}/api/reparations/${id}`, { method:"DELETE" });
    setReps(p => p.filter(r => r.id!==id));
  };
  const apiAddFourn = async () => {
    if (!newFourn.nom) return;
    const res = await fetch(`${API}/api/fournisseurs`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(newFourn) });
    const row = await res.json();
    setFournisseurs(p => [...p, row]);
    setNewFourn({ nom:"", contact:"", tel:"", email:"", delai:"3", remise:"0", adresse:"", site_web:"", notes:"", conditions_paiement:"" });
    setAddFourn(false);
  };
  const apiDeleteFourn = async (id) => {
    await fetch(`${API}/api/fournisseurs/${id}`, { method:"DELETE" });
    setFournisseurs(p => p.filter(f => f.id!==id));
  };
  const saveQty = async (id) => {
    const v = parseInt(tempQty);
    if (!isNaN(v) && v >= 0) await apiUpdateQty(id, v);
    setEditQty(null);
  };

  const handleFile = (file, type) => {
    setIaFile(file); setIaType(type); setIaResult(null); setIaLoading(true); setIaModal(true);
    const formData = new FormData();
    formData.append("fichier", file);
    formData.append("type_facture", type);
    fetch(`${API}/api/factures/analyser`, { method:"POST", body:formData })
      .then(r => r.json())
      .then(data => {
        setIaResult(data); setIaLoading(false);
        reload();
      })
      .catch(() => setIaLoading(false));
  };

  const ruptures  = stock.filter(s => s.qty === 0).length;
  const alertes   = stock.filter(s => s.qty > 0 && s.qty <= s.seuil).length;
  const valeur    = stock.reduce((a,s) => a + s.qty * s.prix_vente, 0);
  const enCours   = reps.filter(r => r.statut === "En cours").length;
  const filtStock = stock.filter(s =>
    (cat==="Tous" || s.categorie===cat) &&
    (s.nom.toLowerCase().includes(search.toLowerCase()) || s.ref.toLowerCase().includes(search.toLowerCase()))
  );

  const NavItem = ({ id, label, icon }) => {
    const active = page === id;
    return (
      <button onClick={() => { setPage(id); setSelectedFourn(null); setSelectedClient(null); }} style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"9px 14px", border:"none", borderLeft:active?`3px solid ${C.G}`:"3px solid transparent", borderRadius:8, cursor:"pointer", textAlign:"left", fontSize:13, marginBottom:2, background:active?C.GL:"transparent", color:active?C.GD:C.MU, fontWeight:active?500:400 }}>
        <span style={{ fontSize:16 }}>{icon}</span>{label}
      </button>
    );
  };

  return (
    <div style={{ display:"flex", minHeight:"100vh", background:C.BG, fontFamily:"'DM Sans','Segoe UI',sans-serif", color:C.TX }}>

      <aside style={{ width:224, background:C.SU, borderRight:`0.5px solid ${C.BR}`, display:"flex", flexDirection:"column", flexShrink:0, height:"100vh", position:"sticky", top:0 }}>
        <div style={{ padding:"20px 16px 16px", borderBottom:`0.5px solid ${C.BR}` }}>
          <div style={{ fontSize:15, fontWeight:600, color:C.GD }}>🔧 {garage.nom}</div>
          <div style={{ fontSize:11, color:C.LI, marginTop:2 }}>Connecté : {user.nom}</div>
        </div>
        <nav style={{ flex:1, padding:"12px 10px", overflowY:"auto" }}>
          <div style={{ fontSize:10, color:C.LI, textTransform:"uppercase", letterSpacing:1, padding:"0 8px", marginBottom:6 }}>Principal</div>
          <NavItem id="dashboard"    label="Dashboard"    icon="📊"/>
          <NavItem id="stock"        label="Stock"         icon="📦"/>
          <NavItem id="clients"      label="Clients"       icon="👤"/>
          <NavItem id="reparations"  label="Réparations"   icon="🔧"/>
          <NavItem id="factures"     label="Factures IA"   icon="🤖"/>
          <div style={{ fontSize:10, color:C.LI, textTransform:"uppercase", letterSpacing:1, padding:"12px 8px 6px" }}>Gestion</div>
          <NavItem id="fournisseurs" label="Fournisseurs"  icon="🏭"/>
          <NavItem id="parametres"   label="Paramètres"    icon="⚙️"/>
        </nav>
        <div style={{ padding:"12px 16px", borderTop:`0.5px solid ${C.BR}` }}>
          {(ruptures > 0 || alertes > 0) && (
            <div style={{ background:"#fef2f2", border:"0.5px solid #fecaca", borderRadius:8, padding:"8px 12px", fontSize:12, color:"#dc2626", marginBottom:8 }}>
              🚨 {ruptures} rupture{ruptures>1?"s":""} · {alertes} alerte{alertes>1?"s":""}
            </div>
          )}
          <button onClick={() => setUser(null)} style={{ width:"100%", padding:"7px", background:"transparent", border:`0.5px solid ${C.BR}`, borderRadius:7, cursor:"pointer", fontSize:12, color:C.MU }}>
            Déconnexion
          </button>
        </div>
      </aside>

      <main style={{ flex:1, overflow:"auto", padding:"28px 32px" }}>

        {/* DASHBOARD */}
        {page === "dashboard" && (
          <div>
            <div style={{ marginBottom:24 }}>
              <div style={{ fontSize:22, fontWeight:500 }}>Bonjour, {user.nom.split(" ")[0]} 👋</div>
              <div style={{ fontSize:13, color:C.MU, marginTop:4 }}>État de votre garage aujourd'hui</div>
            </div>
            <div style={{ display:"flex", gap:12, marginBottom:24, flexWrap:"wrap" }}>
              <Stat label="Articles en stock"    value={stock.length}                        />
              <Stat label="Ruptures"             value={ruptures}    color="#dc2626"          />
              <Stat label="Alertes stock"        value={alertes}     color="#d97706"          />
              <Stat label="Réparations en cours" value={enCours}     color="#2563eb"          />
              <Stat label="Valeur du stock"      value={Math.round(valeur)+" €"} color={C.G} />
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
              <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
                <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>⚠️ Stock en alerte</div>
                {stock.filter(s=>s.qty<=s.seuil).length===0
                  ? <div style={{ fontSize:13, color:C.LI }}>Aucune alerte ✅</div>
                  : stock.filter(s=>s.qty<=s.seuil).map(s => {
                      const st = stockSt(s.qty,s.seuil);
                      return (
                        <div key={s.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${C.BR}` }}>
                          <div>
                            <div style={{ fontSize:13, fontWeight:500 }}>{s.nom}</div>
                            <div style={{ fontSize:11, color:C.MU }}>{s.ref}</div>
                          </div>
                          <Badge label={s.qty===0?"Rupture":`${s.qty} restants`} color={st.color} bg={st.bg}/>
                        </div>
                      );
                    })
                }
              </div>
              <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20 }}>
                <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>👥 Clients récents</div>
                {clients.slice(0,5).map(c => (
                  <div key={c.id} onClick={()=>{setSelectedClient(c.id);setPage("clients");}} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${C.BR}`, cursor:"pointer" }}>
                    <div>
                      <div style={{ fontSize:13, fontWeight:500 }}>{c.nom}</div>
                      <div style={{ fontSize:11, color:C.MU }}>{c.vehicule}</div>
                    </div>
                    <div style={{ fontSize:11, color:C.LI }}>{c.immat}</div>
                  </div>
                ))}
              </div>
              <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20, gridColumn:"1/-1" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
                  <div style={{ fontSize:14, fontWeight:500 }}>🔧 Réparations actives</div>
                  <Btn variant="secondary" small onClick={()=>setPage("reparations")}>Voir tout</Btn>
                </div>
                {reps.filter(r=>r.statut!=="Terminée").map(r => {
                  const cl = clients.find(c=>c.id===r.client_id);
                  const st = repSt(r.statut);
                  return (
                    <div key={r.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:`0.5px solid ${C.BR}` }}>
                      <div>
                        <div style={{ fontSize:13, fontWeight:500 }}>{r.type}</div>
                        <div style={{ fontSize:11, color:C.MU }}>{cl?.nom || r.client_nom} · {cl?.vehicule || r.vehicule} · {fmtDate(r.date)}</div>
                      </div>
                      <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                        <Badge label={r.statut} color={st.color} bg={st.bg}/>
                        <div style={{ fontSize:14, fontWeight:500 }}>{fmt(r.total)}</div>
                      </div>
                    </div>
                  );
                })}
                {reps.filter(r=>r.statut!=="Terminée").length===0 && <div style={{ fontSize:13, color:C.LI }}>Aucune réparation en cours.</div>}
              </div>
            </div>
          </div>
        )}

        {/* STOCK */}
        {page === "stock" && (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <div style={{ fontSize:22, fontWeight:500 }}>Stock des pièces</div>
              <Btn onClick={()=>setAddPiece(true)}>+ Ajouter une pièce</Btn>
            </div>
            <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap", alignItems:"center" }}>
              <input placeholder="Rechercher..." value={search} onChange={e=>setSearch(e.target.value)} style={{ padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, color:C.TX, outline:"none", width:220 }}/>
              <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                {CATS.map(c => (
                  <button key={c} onClick={()=>setCat(c)} style={{ padding:"6px 12px", borderRadius:6, border:`0.5px solid ${cat===c?C.G:C.BR}`, background:cat===c?C.GL:"transparent", color:cat===c?C.GD:C.MU, fontSize:12, cursor:"pointer", fontWeight:cat===c?500:400 }}>{c}</button>
                ))}
              </div>
            </div>
            <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, overflow:"hidden" }}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead>
                  <tr style={{ borderBottom:`0.5px solid ${C.BR}`, background:C.BG }}>
                    {["Désignation","Réf.","Catégorie","Stock","Seuil","Prix achat","Prix vente","Statut",""].map(h=>(
                      <th key={h} style={{ padding:"11px 14px", textAlign:"left", fontSize:11, color:C.MU, fontWeight:500, textTransform:"uppercase", letterSpacing:.5 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtStock.length===0 && <tr><td colSpan={9} style={{ padding:40, textAlign:"center", color:C.LI }}>Aucune pièce trouvée.</td></tr>}
                  {filtStock.map((item,idx) => {
                    const st = stockSt(item.qty,item.seuil);
                    return (
                      <tr key={item.id} style={{ borderBottom:`0.5px solid ${C.BR}`, background:idx%2===0?C.SU:C.BG }}>
                        <td style={{ padding:"11px 14px", fontWeight:500, fontSize:13 }}>{item.nom}</td>
                        <td style={{ padding:"11px 14px", fontSize:12, color:C.MU }}>{item.ref}</td>
                        <td style={{ padding:"11px 14px", fontSize:12 }}>{item.categorie}</td>
                        <td style={{ padding:"11px 14px" }}>
                          {editQty===item.id ? (
                            <div style={{ display:"flex", gap:4 }}>
                              <input autoFocus value={tempQty} onChange={e=>setTempQty(e.target.value)} onKeyDown={e=>e.key==="Enter"&&saveQty(item.id)} style={{ width:52, padding:"4px 8px", border:`0.5px solid ${C.BR}`, borderRadius:5, fontSize:13, outline:"none" }}/>
                              <button onClick={()=>saveQty(item.id)} style={{ background:C.G, color:"#fff", border:"none", borderRadius:5, padding:"4px 8px", cursor:"pointer", fontSize:12 }}>✓</button>
                            </div>
                          ) : (
                            <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                              <button onClick={()=>apiUpdateQty(item.id, Math.max(0,item.qty-1))} style={{ background:C.BG, border:`0.5px solid ${C.BR}`, borderRadius:5, width:24, height:24, cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center" }}>−</button>
                              <span onClick={()=>{setEditQty(item.id);setTempQty(String(item.qty));}} style={{ minWidth:28, textAlign:"center", fontWeight:500, fontSize:15, color:st.color, cursor:"pointer" }}>{item.qty}</span>
                              <button onClick={()=>apiUpdateQty(item.id, item.qty+1)} style={{ background:C.BG, border:`0.5px solid ${C.BR}`, borderRadius:5, width:24, height:24, cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center" }}>+</button>
                            </div>
                          )}
                        </td>
                        <td style={{ padding:"11px 14px", fontSize:13 }}>{item.seuil}</td>
                        <td style={{ padding:"11px 14px", fontSize:13, color:C.MU }}>{fmt(item.prix_achat)}</td>
                        <td style={{ padding:"11px 14px", fontSize:13, fontWeight:500 }}>{fmt(item.prix_vente)}</td>
                        <td style={{ padding:"11px 14px" }}><Badge label={st.label} color={st.color} bg={st.bg}/></td>
                        <td style={{ padding:"11px 14px" }}><button onClick={()=>apiDeletePiece(item.id)} style={{ background:"none", border:"none", color:"#dc2626", cursor:"pointer", fontSize:16 }}>✕</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* CLIENTS */}
        {page === "clients" && (
          selectedClient ? (
            <FicheClient
              id={selectedClient}
              onBack={() => setSelectedClient(null)}
              clients={clients}
              reps={reps}
              onAddRep={(clientId) => { setNewRep(p=>({...p,clientId:String(clientId)})); setAddRep(true); }}
            />
          ) : (
            <div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
                <div style={{ fontSize:22, fontWeight:500 }}>Fiches clients</div>
                <Btn onClick={()=>setAddClient(true)}>+ Nouveau client</Btn>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:16 }}>
                {clients.map(c => {
                  const cReps = reps.filter(r=>r.client_id===c.id);
                  const totalDepense = cReps.reduce((a,r) => a+parseFloat(r.total||0), 0);
                  return (
                    <div key={c.id} style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20, cursor:"pointer" }} onClick={()=>setSelectedClient(c.id)}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                        <div>
                          <div style={{ fontWeight:500, fontSize:15 }}>{c.nom}</div>
                          <div style={{ fontSize:12, color:C.G, marginTop:3 }}>🏍 {c.vehicule}</div>
                        </div>
                        <button onClick={e=>{e.stopPropagation();apiDeleteClient(c.id);}} style={{ background:"none", border:"none", color:C.LI, cursor:"pointer", fontSize:16 }}>✕</button>
                      </div>
                      <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:12 }}>
                        {c.tel   && <span style={{ fontSize:11, color:C.MU }}>📞 {c.tel}</span>}
                        {c.immat && <span style={{ fontSize:11, color:C.MU }}>🪪 {c.immat}</span>}
                        {c.km    && <span style={{ fontSize:11, color:C.MU }}>⏱ {Number(c.km).toLocaleString()} km</span>}
                      </div>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <div style={{ fontSize:12, color:C.MU }}>{cReps.length} intervention{cReps.length!==1?"s":""}</div>
                        <div style={{ fontSize:13, fontWeight:500, color:C.G }}>{fmt(totalDepense)}</div>
                      </div>
                      <div style={{ marginTop:10, fontSize:12, color:C.G, textAlign:"center" }}>Voir la fiche →</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )
        )}

        {/* RÉPARATIONS */}
        {page === "reparations" && (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <div style={{ fontSize:22, fontWeight:500 }}>Réparations & Devis</div>
              <Btn onClick={()=>setAddRep(true)}>+ Nouvelle réparation</Btn>
            </div>
            {reps.map(r => {
              const cl = clients.find(c=>c.id===r.client_id);
              const st = repSt(r.statut);
              return (
                <div key={r.id} style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20, marginBottom:12 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div>
                      <div style={{ fontWeight:500, fontSize:15, marginBottom:4 }}>{r.type}</div>
                      <div style={{ fontSize:12, color:C.MU }}>{cl?.nom || r.client_nom} · {cl?.vehicule || r.vehicule} · {fmtDate(r.date)}{r.km?` · ${Number(r.km).toLocaleString()} km`:""}</div>
                      {r.notes && <div style={{ fontSize:12, color:C.MU, fontStyle:"italic", marginTop:6 }}>📝 {r.notes}</div>}
                    </div>
                    <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                      <Badge label={r.statut} color={st.color} bg={st.bg}/>
                      <div style={{ fontSize:18, fontWeight:500 }}>{fmt(r.total)}</div>
                      <button onClick={()=>apiDeleteRep(r.id)} style={{ background:"none", border:"none", color:C.LI, cursor:"pointer", fontSize:16 }}>✕</button>
                    </div>
                  </div>
                </div>
              );
            })}
            {reps.length===0 && <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:48, textAlign:"center", color:C.LI }}>Aucune réparation enregistrée.</div>}
          </div>
        )}

        {/* FACTURES IA */}
        {page === "factures" && (
          <div>
            <div style={{ marginBottom:24 }}>
              <div style={{ fontSize:22, fontWeight:500 }}>Factures IA</div>
              <div style={{ fontSize:13, color:C.MU, marginTop:4 }}>Mistral analyse vos factures localement — stock et fournisseurs mis à jour automatiquement.</div>
            </div>
            <div style={{ background:"#fffbeb", border:"0.5px solid #fde68a", borderRadius:10, padding:"12px 16px", marginBottom:24, fontSize:12, color:"#854F0B" }}>
              🔒 <strong>100% local</strong> — Mistral tourne sur votre OVH · Données anonymisées avant analyse · PDF stocké sur votre serveur
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
              <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:24, textAlign:"center" }}>
                <div style={{ fontSize:36, marginBottom:12 }}>📥</div>
                <div style={{ fontSize:15, fontWeight:500, marginBottom:6 }}>Facture d'achat</div>
                <div style={{ fontSize:12, color:C.MU, marginBottom:16 }}>Les quantités achetées <strong>entrent</strong> dans le stock · Fournisseur créé automatiquement · PDF sauvegardé</div>
                <UploadBtn label="Choisir une facture achat" type="achat" variant="primary" onFile={handleFile}/>
              </div>
              <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:24, textAlign:"center" }}>
                <div style={{ fontSize:36, marginBottom:12 }}>📤</div>
                <div style={{ fontSize:15, fontWeight:500, marginBottom:6 }}>Facture de vente</div>
                <div style={{ fontSize:12, color:C.MU, marginBottom:16 }}>Les quantités vendues <strong>sortent</strong> du stock automatiquement</div>
                <UploadBtn label="Choisir une facture vente" type="vente" variant="secondary" onFile={handleFile}/>
              </div>
            </div>
          </div>
        )}

        {/* FOURNISSEURS */}
        {page === "fournisseurs" && (
          selectedFourn ? (
            <FicheFournisseur
              id={selectedFourn}
              onBack={() => setSelectedFourn(null)}
              onUpdate={reload}
            />
          ) : (
            <div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
                <div style={{ fontSize:22, fontWeight:500 }}>Fournisseurs</div>
                <Btn onClick={()=>setAddFourn(true)}>+ Ajouter un fournisseur</Btn>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:16 }}>
                {fournisseurs.map(f => (
                  <div key={f.id} style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:20, cursor:"pointer" }} onClick={()=>setSelectedFourn(f.id)}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                      <div>
                        <div style={{ fontWeight:500, fontSize:15 }}>{f.nom}</div>
                        {f.contact && <div style={{ fontSize:12, color:C.MU, marginTop:3 }}>👤 {f.contact}</div>}
                      </div>
                      <button onClick={e=>{e.stopPropagation();apiDeleteFourn(f.id);}} style={{ background:"none", border:"none", color:C.LI, cursor:"pointer", fontSize:16 }}>✕</button>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", gap:5, marginBottom:12 }}>
                      {f.tel   && <span style={{ fontSize:12, color:C.MU }}>📞 {f.tel}</span>}
                      {f.email && <span style={{ fontSize:12, color:C.MU }}>✉️ {f.email}</span>}
                      {f.adresse && <span style={{ fontSize:12, color:C.MU }}>📍 {f.adresse}</span>}
                    </div>
                    <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                      <span style={{ background:"#eff6ff", color:"#2563eb", fontSize:11, padding:"3px 10px", borderRadius:20 }}>⏱ Délai {f.delai}j</span>
                      <span style={{ background:C.GL, color:C.GD, fontSize:11, padding:"3px 10px", borderRadius:20 }}>💰 Remise {f.remise}%</span>
                    </div>
                    <div style={{ fontSize:12, color:C.G, textAlign:"center" }}>Voir la fiche complète →</div>
                  </div>
                ))}
                {fournisseurs.length===0 && <div style={{ fontSize:13, color:C.LI }}>Aucun fournisseur enregistré.</div>}
              </div>
            </div>
          )
        )}

        {/* PARAMÈTRES */}
        {page === "parametres" && (
          <div>
            <div style={{ fontSize:22, fontWeight:500, marginBottom:24 }}>Paramètres du garage</div>
            <div style={{ background:C.SU, border:`0.5px solid ${C.BR}`, borderRadius:12, padding:24, marginBottom:16 }}>
              <div style={{ fontSize:15, fontWeight:500, marginBottom:16 }}>🏢 Informations du garage</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <Inp label="Nom du garage"   value={garage.nom}          onChange={e=>setGarage(p=>({...p,nom:e.target.value}))}/>
                <Inp label="Téléphone"        value={garage.tel}          onChange={e=>setGarage(p=>({...p,tel:e.target.value}))}/>
                <Inp label="Email"            value={garage.email}        onChange={e=>setGarage(p=>({...p,email:e.target.value}))}/>
                <Inp label="SIRET"            value={garage.siret}        onChange={e=>setGarage(p=>({...p,siret:e.target.value}))}/>
                <Inp label="N° TVA"           value={garage.tva}          onChange={e=>setGarage(p=>({...p,tva:e.target.value}))}/>
                <Inp label="Taux horaire (€)" value={garage.taux_horaire} type="number" onChange={e=>setGarage(p=>({...p,taux_horaire:e.target.value}))}/>
                <div style={{ gridColumn:"1/-1" }}><Inp label="Adresse" value={garage.adresse} onChange={e=>setGarage(p=>({...p,adresse:e.target.value}))}/></div>
              </div>
              <div style={{ display:"flex", justifyContent:"flex-end", marginTop:8 }}>
                <Btn onClick={()=>alert("Paramètres enregistrés !")}>💾 Enregistrer</Btn>
              </div>
            </div>
          </div>
        )}

      </main>

      {/* MODAL IA */}
      {iaModal && (
        <Modal title={`Analyse IA — Facture ${iaType==="achat"?"d'achat":"de vente"}`} onClose={()=>setIaModal(false)} width={600}>
          {iaLoading ? (
            <div style={{ textAlign:"center", padding:"32px 0" }}>
              <div style={{ fontSize:36, marginBottom:12 }}>🤖</div>
              {iaFile && <div style={{ fontSize:13, color:C.MU, marginBottom:8 }}>📄 {iaFile.name}</div>}
              <div style={{ fontSize:14, color:C.MU, marginBottom:8 }}>Mistral analyse la facture...</div>
              <div style={{ fontSize:12, color:C.LI }}>OCR → Anonymisation → Analyse Mistral local → Mise à jour stock</div>
            </div>
          ) : iaResult && (
            <div>
              {iaResult.statut === "success" ? (
                <>
                  <div style={{ background:C.GL, border:`0.5px solid ${C.GB}`, borderRadius:8, padding:"10px 14px", fontSize:12, color:C.GD, marginBottom:12 }}>
                    ✅ Analyse terminée · {iaResult.fournisseur && `Fournisseur : ${iaResult.fournisseur} · `}{iaResult.lignes?.length} références · Stock mis à jour automatiquement
                    {iaResult.pieces_creees?.length > 0 && ` · ${iaResult.pieces_creees.length} nouvelle(s) pièce(s) créée(s)`}
                  </div>
                  {iaResult.numero && <div style={{ fontSize:12, color:C.MU, marginBottom:8 }}>N° facture : <strong>{iaResult.numero}</strong> · Total : <strong>{fmt(iaResult.total_ht)}</strong></div>}
                  <table style={{ width:"100%", borderCollapse:"collapse", marginBottom:16 }}>
                    <thead>
                      <tr style={{ borderBottom:`0.5px solid ${C.BR}` }}>
                        {["Réf.","Désignation","Qté","Prix unit.","Total"].map(h=>(
                          <th key={h} style={{ padding:"8px 10px", textAlign:"left", fontSize:11, color:C.MU, fontWeight:500 }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {iaResult.lignes?.map((l,i) => (
                        <tr key={i} style={{ borderBottom:`0.5px solid ${C.BR}` }}>
                          <td style={{ padding:"8px 10px", fontSize:12, color:C.MU }}>{l.ref}</td>
                          <td style={{ padding:"8px 10px", fontSize:13 }}>{l.nom}</td>
                          <td style={{ padding:"8px 10px", fontSize:13, fontWeight:500, color:iaType==="achat"?C.G:"#2563eb" }}>{iaType==="achat"?"+":"-"}{l.qte}</td>
                          <td style={{ padding:"8px 10px", fontSize:13 }}>{fmt(l.pu)}</td>
                          <td style={{ padding:"8px 10px", fontSize:13, fontWeight:500 }}>{fmt(l.qte*l.pu)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{ display:"flex", justifyContent:"flex-end" }}>
                    <Btn onClick={()=>setIaModal(false)}>✅ Fermer</Btn>
                  </div>
                </>
              ) : (
                <div style={{ background:"#fef2f2", border:"0.5px solid #fecaca", borderRadius:8, padding:"12px 16px", fontSize:13, color:"#dc2626" }}>
                  ❌ Erreur : {iaResult.message || "Analyse échouée"}
                </div>
              )}
            </div>
          )}
        </Modal>
      )}

      {/* MODAL PIÈCE */}
      {addPiece && (
        <Modal title="Ajouter une pièce" onClose={()=>setAddPiece(false)}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            <div style={{ gridColumn:"1/-1" }}><Inp label="Nom *" value={newPiece.nom} onChange={e=>setNewPiece(p=>({...p,nom:e.target.value}))}/></div>
            <Inp label="Référence *"   value={newPiece.ref}        onChange={e=>setNewPiece(p=>({...p,ref:e.target.value}))}/>
            <Sel label="Catégorie"     value={newPiece.categorie}  onChange={e=>setNewPiece(p=>({...p,categorie:e.target.value}))}>
              {CATS.map(c=><option key={c}>{c}</option>)}
            </Sel>
            <Inp label="Prix achat (€)" value={newPiece.prix_achat} type="number" onChange={e=>setNewPiece(p=>({...p,prix_achat:e.target.value}))}/>
            <Inp label="Prix vente (€)" value={newPiece.prix_vente} type="number" onChange={e=>setNewPiece(p=>({...p,prix_vente:e.target.value}))}/>
            <Inp label="Quantité"       value={newPiece.qty}        type="number" onChange={e=>setNewPiece(p=>({...p,qty:e.target.value}))}/>
            <Inp label="Seuil alerte"   value={newPiece.seuil}      type="number" onChange={e=>setNewPiece(p=>({...p,seuil:e.target.value}))}/>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
            <Btn variant="secondary" onClick={()=>setAddPiece(false)}>Annuler</Btn>
            <Btn onClick={apiAddPiece}>Ajouter</Btn>
          </div>
        </Modal>
      )}

      {/* MODAL CLIENT */}
      {addClient && (
        <Modal title="Nouveau client" onClose={()=>setAddClient(false)}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            <Inp label="Nom complet *"   value={newClient.nom}      onChange={e=>setNewClient(p=>({...p,nom:e.target.value}))}/>
            <Inp label="Véhicule *"      value={newClient.vehicule} onChange={e=>setNewClient(p=>({...p,vehicule:e.target.value}))}/>
            <Inp label="Téléphone"       value={newClient.tel}      onChange={e=>setNewClient(p=>({...p,tel:e.target.value}))}/>
            <Inp label="Email"           value={newClient.email}    onChange={e=>setNewClient(p=>({...p,email:e.target.value}))}/>
            <Inp label="Immatriculation" value={newClient.immat}    onChange={e=>setNewClient(p=>({...p,immat:e.target.value}))}/>
            <Inp label="Kilométrage"     value={newClient.km}       type="number" onChange={e=>setNewClient(p=>({...p,km:e.target.value}))}/>
            <div style={{ gridColumn:"1/-1" }}><Inp label="Adresse" value={newClient.adresse} onChange={e=>setNewClient(p=>({...p,adresse:e.target.value}))}/></div>
            <div style={{ gridColumn:"1/-1" }}>
              <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>Notes</div>
              <textarea value={newClient.notes||""} onChange={e=>setNewClient(p=>({...p,notes:e.target.value}))} style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, outline:"none", height:60, resize:"vertical", boxSizing:"border-box" }}/>
            </div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
            <Btn variant="secondary" onClick={()=>setAddClient(false)}>Annuler</Btn>
            <Btn onClick={apiAddClient}>Créer</Btn>
          </div>
        </Modal>
      )}

      {/* MODAL RÉPARATION */}
      {addRep && (
        <Modal title="Nouvelle réparation" onClose={()=>setAddRep(false)} width={540}>
          <Sel label="Client *" value={newRep.clientId} onChange={e=>setNewRep(p=>({...p,clientId:e.target.value}))}>
            <option value="">— Sélectionner un client —</option>
            {clients.map(c=><option key={c.id} value={c.id}>{c.nom} — {c.vehicule}</option>)}
          </Sel>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            <Sel label="Type" value={newRep.type} onChange={e=>setNewRep(p=>({...p,type:e.target.value}))}>
              {TYPES_REP.map(t=><option key={t}>{t}</option>)}
            </Sel>
            <Sel label="Statut" value={newRep.statut} onChange={e=>setNewRep(p=>({...p,statut:e.target.value}))}>
              {["En cours","En attente","Terminée","Annulée"].map(s=><option key={s}>{s}</option>)}
            </Sel>
            <Inp label="Date"         value={newRep.date}  type="date"   onChange={e=>setNewRep(p=>({...p,date:e.target.value}))}/>
            <Inp label="Kilométrage"  value={newRep.km}    type="number" onChange={e=>setNewRep(p=>({...p,km:e.target.value}))}/>
            <Inp label="Total HT (€)" value={newRep.total} type="number" onChange={e=>setNewRep(p=>({...p,total:e.target.value}))}/>
          </div>
          <div>
            <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>Notes</div>
            <textarea value={newRep.notes||""} onChange={e=>setNewRep(p=>({...p,notes:e.target.value}))} style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, outline:"none", height:72, resize:"vertical", boxSizing:"border-box" }}/>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
            <Btn variant="secondary" onClick={()=>setAddRep(false)}>Annuler</Btn>
            <Btn onClick={apiAddRep}>Enregistrer</Btn>
          </div>
        </Modal>
      )}

      {/* MODAL FOURNISSEUR */}
      {addFourn && (
        <Modal title="Ajouter un fournisseur" onClose={()=>setAddFourn(false)} width={560}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
            <div style={{ gridColumn:"1/-1" }}><Inp label="Nom *" value={newFourn.nom} onChange={e=>setNewFourn(p=>({...p,nom:e.target.value}))}/></div>
            <Inp label="Contact"            value={newFourn.contact}              onChange={e=>setNewFourn(p=>({...p,contact:e.target.value}))}/>
            <Inp label="Téléphone"          value={newFourn.tel}                  onChange={e=>setNewFourn(p=>({...p,tel:e.target.value}))}/>
            <Inp label="Email"              value={newFourn.email}                onChange={e=>setNewFourn(p=>({...p,email:e.target.value}))}/>
            <Inp label="Site web"           value={newFourn.site_web}             onChange={e=>setNewFourn(p=>({...p,site_web:e.target.value}))}/>
            <Inp label="Délai (jours)"      value={newFourn.delai}                type="number" onChange={e=>setNewFourn(p=>({...p,delai:e.target.value}))}/>
            <Inp label="Remise (%)"         value={newFourn.remise}               type="number" onChange={e=>setNewFourn(p=>({...p,remise:e.target.value}))}/>
            <Inp label="Conditions paiement" value={newFourn.conditions_paiement} onChange={e=>setNewFourn(p=>({...p,conditions_paiement:e.target.value}))}/>
            <div style={{ gridColumn:"1/-1" }}><Inp label="Adresse" value={newFourn.adresse} onChange={e=>setNewFourn(p=>({...p,adresse:e.target.value}))}/></div>
            <div style={{ gridColumn:"1/-1" }}>
              <div style={{ fontSize:11, color:C.MU, marginBottom:4, textTransform:"uppercase", letterSpacing:.5 }}>Notes</div>
              <textarea value={newFourn.notes||""} onChange={e=>setNewFourn(p=>({...p,notes:e.target.value}))} style={{ width:"100%", padding:"8px 12px", border:`0.5px solid ${C.BR}`, borderRadius:7, fontSize:13, outline:"none", height:60, resize:"vertical", boxSizing:"border-box" }}/>
            </div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
            <Btn variant="secondary" onClick={()=>setAddFourn(false)}>Annuler</Btn>
            <Btn onClick={apiAddFourn}>Ajouter</Btn>
          </div>
        </Modal>
      )}

    </div>
  );
}
